require("isomorphic-fetch");

export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";

// Actions}

export function setSearchQuery(searchQuery) {
  return { type: SET_SEARCH_QUERY, searchQuery: searchQuery };
}
